import { type Component, createSignal } from 'solid-js'
import { clickOutside } from '../../shared/directives/click-outside'
import { useClerk, useUser as useClerkUser } from '../../shared/providers/clerk'
import { Trans } from '@mbarzda/solid-i18next'
import UserAvatar from '../shared/components/UserAvatar'

const UserMenu: Component = () => {
  const [isMenuOpen, setMenuOpen] = createSignal(false)
  const clerk = useClerk()
  const clerkUser = useClerkUser()

  const toggleMenu = (): void => {
    setMenuOpen(!isMenuOpen())
  }

  const onLogout = async (): Promise<void> => {
    localStorage.clear()
    await clerk().signOut({ redirectUrl: window.location.origin })
  }

  const userName = () => {
    const user = clerkUser.user()
    return user?.username ?? user?.emailAddresses?.[0]?.emailAddress ?? 'User'
  }

  const userAvatar = () => {
    return clerkUser.user()?.imageUrl ?? ''
  }

  return (
    <div data-test-user-menu class="flex items-center relative">
      <button
        onClick={toggleMenu}
        type="button"
        class="-m-1.5 flex items-center p-1.5 gap-2"
        id="user-menu-button"
        aria-expanded={isMenuOpen()}
        aria-haspopup="true"
      >
        <span class="sr-only">Open user menu</span>
        <UserAvatar
          src={userAvatar()}
          name={userName()}
          class="h-8 min-w-[32px] w-8 rounded-full bg-gray-50 object-cover"
        />
        <span class="hidden lg:flex lg:items-center gap-1">
          <span class="text-sm font-medium text-gray-700">{userName()}</span>
          <svg class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path
              fill-rule="evenodd"
              d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
              clip-rule="evenodd"
            />
          </svg>
        </span>
      </button>
      <div
        ref={(el) => {
          clickOutside(el, () => setMenuOpen(false))
        }}
        class={`${
          isMenuOpen() ? 'visible' : 'hidden'
        } flex flex-col absolute top-10 right-0 z-20 mt-1 min-w-[224px] origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-gray-900/5 focus:outline-none`}
        role="menu"
        aria-orientation="vertical"
        aria-labelledby="user-menu-button"
        tabindex="-1"
      >
        <button
          onClick={onLogout}
          class="bg-white hover:bg-gray-50 px-4 py-2 text-sm text-gray-700 text-left whitespace-nowrap"
          role="menuitem"
          tabIndex="-1"
        >
          <Trans key="ls_generic_logout" />
        </button>
      </div>
    </div>
  )
}

export default UserMenu
